
import { defineComponent, inject, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import i18n from '@/core/plugins/i18n';
import Notify from '@/core/services/Notify';
export default defineComponent({
    setup() {
        const route = useRoute();
        const appInstance: any = inject('instance');
        const store = useStore();
        const router = useRouter();
        const permission_error = ref(false);
        const ASSETS_CLIENT_NAME = process.env.VUE_APP_ASSETS_CLIENT_NAME;

        // Handle Entra error param
        const handle_entra_error = (message: string) => {
            localStorage.removeItem('token');
            permission_error.value = true;
            Notify.error(message || i18n.global.t('message.UNAUTHORIZED_USER'));
        };

        // Handle token returned directly by yellowrockshopapis Entra callback
        const handle_entra_token = async (token: string) => {
            try {
                localStorage.setItem('token', token);
                localStorage.removeItem('session-timestamp');

                const response = await store.dispatch('abilities', appInstance);

                if (response && !response?.data?.roles?.admin) {
                    localStorage.removeItem('token');
                    permission_error.value = true;
                    setTimeout(() => {
                        window.location.href = process.env.VUE_APP_GEP_SHOP;
                    }, 3000);
                } else {
                    router.push({ name: 'dashboard' });
                }
            } catch (e) {
                localStorage.removeItem('token');
                permission_error.value = true;
            }
        };

        const dynamicAsset = computed(() => {
            return require(`@/assets/media/${ASSETS_CLIENT_NAME}/${ASSETS_CLIENT_NAME}_logo.png`);
        });

        // Entry point — Entra redirects back with ?token= or ?error=
        if (route.query.error) {
            handle_entra_error(route.query.error as string);
        } else if (route.query.token) {
            handle_entra_token(route.query.token as string);
        } else if (localStorage.getItem('token') == null) {
            // No token yet — send to Entra login
            window.location.href = `${process.env.VUE_APP_GEP_BASE_URL}/auth/entra/login?return_to=${process.env.VUE_APP_CLIENT_CALLBACK}`;
        }

        return {
            permission_error,
            ASSETS_CLIENT_NAME,
            dynamicAsset
        };
    }
});
